import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { NavAdditionalLink } from "~/features/app/app-header-v2/nav-additional-links/nav-additional-link";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import { NavAdditionalDropdown } from "~/features/app/app-header-v2/nav-additional-links/nav-additional-dropdown";
const fragment = graphql(`
  fragment NavAdditionalLinksV2 on navAdditionalLinks_NeoField {
    __typename
    ...NavAdditionalLinkV2
    ...NavAdditionalDropdownV2
  }
`);
type Props = {
  navLinks: FragmentType<typeof fragment>[];
  variant?: keyof typeof variants;
};
const variants = {
  transparent: {
    "> :not([hidden]) ~ :not([hidden])": {
      "borderColor": "rgba(255, 255, 255, 0.2)"
    },
    "borderColor": "rgba(255, 255, 255, 0.2)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  solid: {
    "> :not([hidden]) ~ :not([hidden])": {
      "borderColor": "rgb(0 7 4 / 0.1)"
    },
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(244 244 249 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  },
  highlighted: {
    "> :not([hidden]) ~ :not([hidden])": {
      "borderColor": "rgb(0 7 4 / 0.1)"
    },
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }
} as const;
export function NavAdditionalLinks(props: Props) {
  const {
    navLinks,
    variant
  } = props;
  const links = useFragment(fragment, navLinks);
  const {
    navTheme,
    isPageHighlighted
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : variant || navTheme;
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledUl $_css={[{
    "pointerEvents": "auto",
    "zIndex": "101",
    "display": "flex",
    "height": "var(--header-height)",
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-divide-x-reverse": "0",
      "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
      "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))"
    },
    "borderBottomWidth": "1px",
    "borderLeftWidth": "1px",
    "borderRightWidth": "1px",
    "borderColor": "inherit",
    "fontSize": "1.6rem",
    "lineHeight": "1.5",
    "fontWeight": "400",
    "--tw-backdrop-blur": "blur(8px)",
    "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
  }, variants[surface], {
    "transform": "translateZ(0)"
  }]}>
      {links.map((item, idx) => {
      if (item.__typename === "navAdditionalLinks_link_BlockType") {
        return <_StyledLi key={idx}>
              <_StyledNavAdditionalLink {...item} />
            </_StyledLi>;
      }
      if (item.__typename === "navAdditionalLinks_dropdown_BlockType") {
        return <_StyledLi2 key={idx}>
              <NavAdditionalDropdown variant={surface} {...item} />
            </_StyledLi2>;
      }
      return null;
    })}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  componentId: "sc-sf-xi20xi-0"
})`${p => p.$_css}`;
var _StyledLi = _styled2("li").withConfig({
  componentId: "sc-sf-xi20xi-1"
})({
  "position": "relative",
  "height": "100%"
});
var _StyledNavAdditionalLink = _styled3(NavAdditionalLink).withConfig({
  componentId: "sc-sf-xi20xi-2"
})({
  "paddingLeft": "4rem",
  "paddingRight": "4rem"
});
var _StyledLi2 = /*#__PURE__*/_styled4("li").withConfig({
  displayName: "nav-additional-links___StyledLi2",
  componentId: "sc-lbgzqv-0"
})({
  "position": "relative",
  "height": "100%"
});